<template>
  <section v-bind="sectionProps">
    <v-container v-bind="containerProps">
      <v-row v-bind="contentRowProps">
        <v-col v-bind="contentColumnProps">
          <div
            class="section-title"
            v-bind="titleProps"
            v-inline-editable.html="section.content['title']"
          ></div>

          <div
            class="section-introtext"
            v-bind="introtextProps"
            v-inline-editable.html="section.content['introtext']"
          ></div>

          <div
            v-if="
              parseBoolean(section.layout['content-box']) &&
                section.layout['content-box-wrap'] == 'content'
            "
            v-bind="contentBoxProps"
          ></div>

          <v-row
            class="section-items"
            v-bind="itemRowProps"
            v-if="
              section.content['images'] &&
                JSON.parse(section.content['images']).length
            "
          >
            <v-col
              class="section-item"
              v-bind="itemColumnProps"
              v-for="(item, index) in JSON.parse(section.content['images'])"
              :key="index"
            >
              <v-img
                class="item-image"
                v-if="item['item-image']"
                v-bind="itemImageProps(item)"
              >
                <v-container class="item-content" v-bind="itemContentProps">
                  <v-row no-gutters>
                    <v-col cols="12">
                      <div
                        class="item-title"
                        v-bind="itemTitleProps"
                        v-inline-editable.html="item['item-title']"
                      ></div>
                    </v-col>

                    <v-col
                      cols="12"
                      v-if="item['button-text'] && item['button-link']"
                    >
                      <link-button
                        class="item-button"
                        :link="item['button-link']"
                        :text="item['button-text']"
                        v-bind="buttonProps(item)"
                      ></link-button>
                    </v-col>

                    <div
                      v-if="
                        parseBoolean(section.layout['content-box']) &&
                          section.layout['content-box-wrap'] == 'item'
                      "
                      v-bind="contentBoxProps"
                    ></div>
                  </v-row>
                </v-container>
              </v-img>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>

    <parallax-background-image
      v-if="section.design['background-image']"
      :section="section"
      v-bind="backgroundImageProps"
    ></parallax-background-image>

    <slot name="toolbar"></slot>
  </section>
</template>

<script>
import LinkButton from '@/components/sections/partials/buttons/LinkButton'
import ParallaxBackgroundImage from '@/components/sections/partials/elements/ParallaxBackgroundImage'

export default {
  name: 'MediaGalleryDefaultSection',
  props: {
    section: {
      type: Object,
      required: true
    },
    templateSettings: {
      type: Object,
      required: true
    },
    builder: {
      type: Boolean,
      default: true
    }
  },
  components: {
    LinkButton,
    ParallaxBackgroundImage
  },
  computed: {
    sectionProps() {
      let additionalStyle = {}

      if (this.parseBoolean(this.section.design['custom-padding'])) {
        additionalStyle.paddingTop = this.section.design['padding-top']
        additionalStyle.paddingBottom = this.section.design['padding-bottom']
      }

      return {
        style: {
          backgroundColor: this.section.design['background-color'],
          ...additionalStyle
        }
      }
    },
    backgroundImageProps() {
      return {
        style: {
          position: 'absolute',
          top: 0,
          bottom: 0,
          left: 0,
          right: 0
        }
      }
    },
    containerProps() {
      return {
        fluid: this.parseBoolean(
          this.section.layout['content-container-fluid']
        ),
        class: {
          'px-0':
            this.parseBoolean(this.section.layout['content-container-fluid']) &&
            this.parseBoolean(this.section.layout['content-no-gutters'])
        },
        'fill-height': true,
        style: {
          position: 'relative',
          zIndex: 1
        }
      }
    },
    contentRowProps() {
      return {
        'no-gutters': true,
        class: [
          `justify-${this.section.layout['content-horizontal-alignment']}`,
          `text-${this.section.layout['content-horizontal-alignment']}`
        ]
      }
    },
    contentColumnProps() {
      return {
        ...this.calculateColumnContainerSize(
          this.section.layout['content-container-size']
        ),
        style: {
          position: 'relative',
          padding:
            this.parseBoolean(this.section.layout['content-box']) &&
            this.section.layout['content-box-wrap'] == 'content'
              ? this.section.layout['content-box-padding']
              : 0
        }
      }
    },
    titleProps() {
      return {
        is: this.section.design['title-tag'],
        style: {
          color: this.section.design['title-color'],
          fontWeight: this.section.design['title-font-weight'],
          margin: this.section.content['title'] ? '' : '0',
          paddingLeft:
            this.parseBoolean(this.section.layout['content-container-fluid']) &&
            this.parseBoolean(this.section.layout['content-no-gutters'])
              ? 'var(--column-spacing)'
              : '0',
          paddingRight:
            this.parseBoolean(this.section.layout['content-container-fluid']) &&
            this.parseBoolean(this.section.layout['content-no-gutters'])
              ? 'var(--column-spacing)'
              : '0'
        }
      }
    },
    introtextProps() {
      return {
        class: { 'mb-5': this.section.content['introtext'] },
        style: {
          color: this.section.design['introtext-color']
        }
      }
    },
    itemRowProps() {
      return {
        justify: this.section.layout['content-horizontal-alignment'],
        'no-gutters': this.parseBoolean(
          this.section.layout['content-no-gutters']
        )
      }
    },
    itemColumnProps() {
      return {
        ...this.calculateColumns(this.section.layout['item-columns'])
      }
    },
    itemContentProps() {
      return {
        class: ['fill-height', 'align-content-center'],
        style: {
          position: 'relative',
          padding:
            this.parseBoolean(this.section.layout['content-box']) &&
            this.section.layout['content-box-wrap'] == 'item'
              ? this.section.layout['content-box-padding']
              : 0
        }
      }
    },
    itemTitleProps() {
      return {
        is: this.section.design['item-title-tag'],
        style: {
          color: this.section.design['item-title-color'],
          fontWeight: this.section.design['item-title-font-weight']
        }
      }
    },
    contentBoxProps() {
      let additionalClass = []

      if (this.parseBoolean(this.section.layout['content-box-rounded'])) {
        additionalClass.push('rounded')
      }

      return {
        class: [
          `elevation-${this.section.layout['content-box-elevation']}`,
          ...additionalClass
        ],
        style: {
          position: 'absolute',
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: -1,
          backgroundColor: this.section.layout['content-box-color'],
          opacity: this.section.layout['content-box-opacity'],
          border: `${this.section.layout['content-box-border']}px solid ${this.section.layout['content-box-border-color']}`
        }
      }
    },
    itemImageSize() {
      switch (this.section.layout['item-columns']) {
        case '1':
          return 'lg'
        case '2':
          return 'md'
        case '3':
          return 'md'
        case '4':
          return 'sm'
        case '5':
          return 'sm'
        case '6':
          return 'xs'
        default:
          return 'lg'
      }
    }
  },
  methods: {
    itemImageProps(item) {
      return {
        src: this.loadMedia(item['item-image'], this.itemImageSize),
        'aspect-ratio':
          this.section.layout['item-size'] == 'aspect-ratio'
            ? this.section.layout['item-aspect-ratio']
            : undefined,
        'lazy-src': this.loadMedia(item['item-image'], 'thumbnail'),
        class: {
          'mb-2': !this.parseBoolean(this.section.layout['content-no-gutters'])
        },
        style: {
          width: '100%',
          padding: this.section.layout['inner-content-padding']
        }
      }
    },
    buttonTextColor(button) {
      let color = button['button-text-color']

      if (
        button['button-style'] === 'default' &&
        button['button-text-color'] === 'inherit'
      ) {
        if (button['button-background-color'] === 'var(--primary-color)') {
          let defaultColor = getComputedStyle(
            document.documentElement
          ).getPropertyValue('--primary-text-color')

          color = `var(--text-${defaultColor}-color)`
        } else if (
          button['button-background-color'] === 'var(--secondary-color)'
        ) {
          let defaultColor = getComputedStyle(
            document.documentElement
          ).getPropertyValue('--secondary-text-color')

          color = `var(--text-${defaultColor}-color)`
        }
      }

      return color
    },
    buttonProps(item) {
      return {
        class: ['mr-3', 'mb-3'],
        depressed: true,
        outlined: item['button-style'] == 'outlined',
        text: item['button-style'] == 'text',
        color:
          item['button-style'] == 'text'
            ? 'transparent'
            : item['button-background-color'],
        style: {
          color: this.buttonTextColor(item),
          borderColor: item['button-background-color']
        }
      }
    }
  }
}
</script>
